import React, { PropTypes } from 'react';
import {isEmpty, get} from 'lodash';
import cx from 'classnames';

export default function TopNavigation(props) {

  return (
    <div className='top-navigation'>
        <ul className={`application-progress ${props.className}`}>
          {
            props.links.map((link, index) => {
              
              return (
                <li
                  key={index}
                  data-id={link.name}
                  className={
                    cx('subnav-button',
                       {active: link.categoryId === props.activeCategoryId},
                       {bottomBorder: true},
                       {highlightedCircleEdge: true},
                       {checked:!isEmpty(get(props.jobRequest, `skills.${link.categoryId}`))})
                  }>
                  <div className='subnav-text-container'>
                    <span className='subnav-text'>{link.name}</span>
                  </div>
                </li>
              );
            })
          }
        </ul>
    </div>
  );
}

TopNavigation.propTypes = {
  links: PropTypes.array,
  activeCategoryId : PropTypes.string,
  className: PropTypes.string,
  jobId: PropTypes.integer,
  jobRequest: PropTypes.Object,
};



// WEBPACK FOOTER //
// ./shared/react/client/JobRequest/Skills/TopNavigation/index.js